import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

export function ArrowLink({
  to,
  children,
  dark = false,
  onClick,
}: {
  to?: string;
  children: ReactNode;
  dark?: boolean;
  onClick?: () => void;
}) {
  const classes = `group inline-flex items-center gap-2 text-sm font-medium ${
    dark ? 'text-cream' : 'text-ink'
  }`;

  const content = (
    <>
      <span className="relative">
        {children}
        <span
          className={`absolute -bottom-0.5 left-0 h-px w-full origin-left scale-x-100 transition-transform duration-300 group-hover:scale-x-0 ${
            dark ? 'bg-cream/60' : 'bg-ink/40'
          }`}
        />
      </span>
      <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
    </>
  );

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={classes}>
        {content}
      </button>
    );
  }

  return (
    <Link to={to ?? '#'} className={classes}>
      {content}
    </Link>
  );
}
